import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

export const imageUrl = (id, w) => `${API}/images/${id}${w ? `?w=${w}` : ""}`;

export const api = {
  meta: () => axios.get(`${API}/meta`).then((r) => r.data),
  v2KeyStatus: () => axios.get(`${API}/pipeline-v2/anthropic-key`).then((r) => r.data),
  v2KeySave: (key) => axios.put(`${API}/pipeline-v2/anthropic-key`, { key }).then((r) => r.data),
  v2KeyDelete: () => axios.delete(`${API}/pipeline-v2/anthropic-key`).then((r) => r.data),
  v2KeyTest: () => axios.post(`${API}/pipeline-v2/anthropic-key/test`).then((r) => r.data),
  generate: (payload) => axios.post(`${API}/books/generate`, payload).then((r) => r.data),
  getBook: (id, share = "") => axios.get(`${API}/books/${id}`, { params: { _: Date.now(), ...(share ? { share } : {}) } }).then((r) => r.data),
  setEndorsement: (id, quote, by) => axios.put(`${API}/books/${id}/marketing/endorsement`, { quote, by }).then((r) => r.data),
  createShare: (id) => axios.post(`${API}/books/${id}/share`).then((r) => r.data),
  revokeShare: (id) => axios.delete(`${API}/books/${id}/share`).then((r) => r.data),
  listBooks: () => axios.get(`${API}/books`).then((r) => r.data),
  deleteBook: (id) => axios.delete(`${API}/books/${id}`).then((r) => r.data),
  updateBook: (id, patch) => axios.patch(`${API}/books/${id}`, patch).then((r) => r.data),
  retryBook: (id) => axios.post(`${API}/books/${id}/retry`).then((r) => r.data),
  regenCover: (id) => axios.post(`${API}/books/${id}/regenerate/cover`).then((r) => r.data),
  regenChapter: (id, number) => axios.post(`${API}/books/${id}/regenerate/chapter/${number}`).then((r) => r.data),
  rewriteChapter: (id, number, instruction) => axios.post(`${API}/books/${id}/chapters/${number}/rewrite`, { instruction }).then((r) => r.data),
  coverOptions: (id, style) => axios.post(`${API}/books/${id}/covers/options`, { style }).then((r) => r.data),
  coverDesigns: (id) => axios.post(`${API}/books/${id}/cover/designs`).then((r) => r.data),
  applyCoverDesign: (id, index) => axios.post(`${API}/books/${id}/cover/design`, { index }).then((r) => r.data),
  restoreCover: (id, version_id) => axios.post(`${API}/books/${id}/cover/restore`, { version_id }).then((r) => r.data),
  selectCover: (id, image_id) => axios.post(`${API}/books/${id}/cover/select`, { image_id }).then((r) => r.data),
  continuityCheck: (id) => axios.post(`${API}/books/${id}/continuity/check`).then((r) => r.data),
  addChapter: (id, after_number, title, focus) =>
    axios.post(`${API}/books/${id}/chapters/add`, { after_number, title, focus }).then((r) => r.data),
  deleteChapter: (id, number) => axios.delete(`${API}/books/${id}/chapters/${number}`).then((r) => r.data),
  startAudiobook: (id, voice, read_along) => axios.post(`${API}/books/${id}/audiobook`, { voice, read_along }).then((r) => r.data),
  audiobookUrl: (id) => `${API}/books/${id}/audio`,
  exportUrl: (id, fmt) => `${API}/books/${id}/export/${fmt}`,
  printPdfUrl: (id, trim = "", bleed = true) =>
    `${API}/books/${id}/export/pdf?layout=print&trim=${encodeURIComponent(trim)}&bleed=${bleed}`,
  epubUrl: (id) => `${API}/books/${id}/export/epub`,
  kdpUrl: (id, trim = "", bleed = true) =>
    `${API}/books/${id}/export/kdp?trim=${encodeURIComponent(trim)}&bleed=${bleed}`,
  coverUrl: (id, trim = "", bleed = true, kind = "wrap") =>
    `${API}/books/${id}/export/cover?trim=${encodeURIComponent(trim)}&bleed=${bleed}&kind=${kind}`,
  interiorPreview: (id, trim = "") =>
    axios.get(`${API}/books/${id}/interior-preview`, { params: { trim } }).then((r) => r.data),
  wrapPreview: (id, trim = "") =>
    axios.get(`${API}/books/${id}/cover/wrap-preview`, { params: { trim } }).then((r) => r.data),
  readmeUrl: (id) => `${API}/books/${id}/export/readme`,
  marketingKit: (id) => axios.post(`${API}/books/${id}/marketing`).then((r) => r.data),

  // ---- series ----
  createSeries: (payload) => axios.post(`${API}/series`, payload).then((r) => r.data),
  listSeries: () => axios.get(`${API}/series`).then((r) => r.data),
  getSeries: (id) => axios.get(`${API}/series/${id}`).then((r) => r.data),
  updateSeries: (id, payload) => axios.patch(`${API}/series/${id}`, payload).then((r) => r.data),

  // ---- auth ----
  me: () => axios.get(`${API}/auth/me`).then((r) => r.data.user),
  register: (payload) => axios.post(`${API}/auth/register`, payload).then((r) => r.data.user),
  login: (payload) => axios.post(`${API}/auth/login`, payload).then((r) => r.data.user),
  forgotPassword: (email) => axios.post(`${API}/auth/forgot-password`, { email }).then((r) => r.data),
  resetPassword: (token, password) => axios.post(`${API}/auth/reset-password`, { token, password }).then((r) => r.data),
  googleExchange: (session_id, ref = "") => axios.post(`${API}/auth/google`, { session_id, ref }).then((r) => r.data.user),
  marketResearch: (niche = "") => axios.post(`${API}/market/research`, { niche }).then((r) => r.data),
  marketAmazon: (q, limit = 6) => axios.post(`${API}/market/amazon`, { q, limit }).then((r) => r.data),
  listSavedResearch: () => axios.get(`${API}/market/saved`).then((r) => r.data),
  saveResearch: (payload) => axios.post(`${API}/market/saved`, payload).then((r) => r.data),
  deleteSavedResearch: (id) => axios.delete(`${API}/market/saved/${id}`).then((r) => r.data),
  googleConfig: () => axios.get(`${API}/auth/google/config`).then((r) => r.data),
  googleCallback: (code, redirect_uri, ref = "") => axios.post(`${API}/auth/google/callback`, { code, redirect_uri, ref }).then((r) => r.data.user),
  logout: () => axios.post(`${API}/auth/logout`).then((r) => r.data),
  unlockPublish: (id) => axios.post(`${API}/books/${id}/publish/unlock`).then((r) => r.data),
  completeBook: (id) => axios.post(`${API}/books/${id}/complete`).then((r) => r.data),

  // ---- payments ----
  catalog: () => axios.get(`${API}/payments/catalog`).then((r) => r.data.products),
  catalogFull: () => axios.get(`${API}/payments/catalog`).then((r) => r.data),
  checkout: (lookup_key, opts = {}) =>
    axios.post(`${API}/payments/checkout`, {
      lookup_key,
      quantity: opts.quantity || 1,
      book_id: opts.book_id || "",
      series_id: opts.series_id || "",
      origin_url: window.location.origin,
    }).then((r) => r.data),
  paymentStatus: (session_id) => axios.get(`${API}/payments/status/${session_id}`).then((r) => r.data),

  // ---- billing ----
  billing: () => axios.get(`${API}/billing/overview`).then((r) => r.data),
  cancelSubscription: () => axios.post(`${API}/billing/cancel`).then((r) => r.data),
  redeemPromo: (code) => axios.post(`${API}/promo/redeem`, { code }).then((r) => r.data),

  // ---- admin ----
  continuityPropose: (id, fid) => axios.post(`${API}/books/${id}/continuity/findings/${fid}/propose`).then((r) => r.data),
  continuityApply: (id, fid) => axios.post(`${API}/books/${id}/continuity/findings/${fid}/apply`).then((r) => r.data),
  continuityReject: (id, fid) => axios.post(`${API}/books/${id}/continuity/findings/${fid}/reject`, {}).then((r) => r.data),
  continuityUndo: (id, fixId) => axios.post(`${API}/books/${id}/continuity/fixes/${fixId}/undo`).then((r) => r.data),
  adminAiCosts: (days = 30) => axios.get(`${API}/admin/ai-costs`, { params: { days } }).then((r) => r.data),
  adminSaveAiCostSettings: (body) => axios.put(`${API}/admin/ai-costs/settings`, body).then((r) => r.data),
  adminMetrics: () => axios.get(`${API}/admin/metrics`).then((r) => r.data),
  adminGeneration: () => axios.get(`${API}/admin/generation`).then((r) => r.data),
  adminSetGeneration: (max_workers) => axios.put(`${API}/admin/generation`, { max_workers }).then((r) => r.data),
  adminListUsers: (q = "", limit = 25) => axios.get(`${API}/admin/users`, { params: { q, limit } }).then((r) => r.data),
  adminGrantUser: (user_id, kind, amount = 0) => axios.post(`${API}/admin/users/${user_id}/grant`, { kind, amount }).then((r) => r.data),
  adminSetCredited: (user_id, credited) => axios.patch(`${API}/admin/users/${user_id}/credited`, { credited }).then((r) => r.data),
  adminListPromo: () => axios.get(`${API}/admin/promo`).then((r) => r.data),
  adminCreatePromo: (payload) => axios.post(`${API}/admin/promo`, payload).then((r) => r.data),
  adminTogglePromo: (code) => axios.patch(`${API}/admin/promo/${code}`).then((r) => r.data),
  adminDeletePromo: (code) => axios.delete(`${API}/admin/promo/${code}`).then((r) => r.data),
};

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || fallback;
}
